// extracted by css-extract-rspack-plugin
export default {"input":"xE_vM","error":"LFOFf"};